import type { Offer } from '@fourthwall/services/dist/models/offer'

export const LABEL_BY_FULFILLMENT_SERVICE: Record<Offer.FulfillingService, string> = {
  BUNDLE: 'Bundle',
  BOLT_STITCH: 'Bolt Stitch',
  CART_JAZZ: 'Cart Jazz',
  CHIVA_TOYS: 'Chiva Toys',
  COMBINED: 'Combined',
  COSMOPOLITAN: 'Cosmopolitan',
  CTC: 'CTC',
  DIGITAL_ITEM: 'Digital item',
  DOD: 'DOD',
  DUBOW: 'Dubow',
  DUBOW_ORDER_DESK: 'Dubow OrderDesk',
  FULFILLED_BY_CREATOR: 'Fulfilled by Creator',
  FULFILLED_BY_FOURTHWALL: 'Fulfilled by Fourthwall',
  FULFILLED_BY_MANUFACTURER: 'Fulfilled by Manufacturer',
  GIFT_CARD: 'Gift Card',
  GNARLYWOOD: 'Gnarlywood',
  HOMEMADE_MERCH: 'Homemade Merch (TMG)',
  KNITWISE: 'Knitwise',
  MOGUL_MERCH_LOCAL: 'Mogul Merch (ShipStation)',
  MOGUL_MERCH_SHIP_BOB: 'Mogul Merch (ShipBob)',
  MWW: 'MWW',
  OFFLINE_TV_SHIPSTATION: 'OfflineTv (ShipStation)',
  OPTIGER: 'OPTiger',
  OVERCAST: 'Overcast',
  P3: 'P3',
  P3_ORDER_DESK: 'P3 OrderDesk',
  PRINTFUL: 'Printful',
  REDWALL: 'Redwall',
  RVLT_SHIP_HERO: 'Revolt (ShipHero)',
  SEVENTY_EIGHT_STRANGE: '78 Strange (Pointcrow / Mogul)',
  SHIP_MONK: 'ShipMonk',
  SPOKE: 'Spoke',
  SUPER_CULTURE: 'Super Culture (MogulMerch / ShipBob)',
  STAKES: 'Stakes',
  TRIBE: 'Tribe',
  USOURCED: 'USourced',
  WALTER_SUPPLY: 'Walter Supply',
  WHIPLASH_3PL: 'Whiplash 3PL',
  WHIPLASH_FREE: 'Whiplash Free',
  WLM: 'WLM',
  WLM_3PL: 'WLM 3PL',
}

export const LABEL_BY_MANUFACTURING_SERVICE: Record<Offer.ManufacturingService, string> = {
  FOURTHWALL_BESPOKE: 'Fourthwall Bespoke',
  MANUFACTURED_BY_CREATOR: 'Manufactured by Creator',
  SPOKE: 'Spoke',
  PRINTFUL: 'Printful',
  WLM: 'WLM',
  DIGITAL_ITEM: 'Digital Item',
  DUBOW: 'Dubow',
  DUBOW_DTFX: 'Dubow DTFX',
  TRIBE: 'Tribe',
  OPTIGER: 'OP Tiger',
  OVERCAST: 'Overcast',
  REDWALL: 'Redwall',
  MWW: 'MWW',
  P3: 'P3',
  DEMO_PRODUCT: 'Demo Product',
  KNITWISE: 'Knitwise',
  DOD: 'DOD',
  COMBINED: 'Combined',
  BUNDLE: 'Bundle',
  STAKES: 'Stakes',
}

export const SHIPPING_MODAL_HASH = '#shipping-modal-open'

export const YOU_FULFILL: Offer.FulfillingService[] = [
  'FULFILLED_BY_CREATOR',
  'COSMOPOLITAN',
  'BOLT_STITCH',
  'SUPER_CULTURE',
  'HOMEMADE_MERCH',
  'SEVENTY_EIGHT_STRANGE',
  'MOGUL_MERCH_LOCAL',
  'RVLT_SHIP_HERO',
  'MOGUL_MERCH_SHIP_BOB',
  'OFFLINE_TV_SHIPSTATION',
  'GNARLYWOOD',
]
